import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateRentalAgreementDto } from '../../../rental-agreements/dtos/create-rental-agreement.dto';
import { UpdateRentalAgreementDto } from '../../../rental-agreements/dtos/update-rental-agreement.dto';
import { createRentalAgreementSchema } from '../schemas/create-rental-agreement.schema';
import { updateRentalAgreementSchema } from '../schemas/update-rental-agreement.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateRentalAgreementDto | UpdateRentalAgreementDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateRentalAgreementSchema if 'id' is present
		validationResult = updateRentalAgreementSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createRentalAgreementSchema if 'id' is not present
		validationResult = createRentalAgreementSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
